/**
 * 계정 삭제 확인 모달.
 * Figma「Modal/삭제 확인」(node 12679:4567) — RDS Dialog.
 * 계정 ID(이메일)를 정확히 입력해야 삭제가 활성화된다.
 */
import { Button } from '@/shared/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/shared/components/ui/dialog';
import { Input } from '@/shared/components/ui/input';
import { Label } from '@/shared/components/ui/label';
import { popupSecondaryButtonClassName } from '@/shared/components/ui/popup-styles';
import React, { useEffect, useState } from 'react';

export type AccountDeleteConfirmModalProps = {
  open: boolean;
  email: string;
  name: string;
  onClose: () => void;
  onConfirm: () => void;
};

export const AccountDeleteConfirmModal: React.FC<
  AccountDeleteConfirmModalProps
> = ({ open, email, name, onClose, onConfirm }) => {
  const [confirmId, setConfirmId] = useState('');
  const canDelete = confirmId.trim() === email;
  const showErrorTone = confirmId.length > 0 && !canDelete;

  useEffect(() => {
    if (open) {
      setConfirmId('');
    }
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={(next) => !next && onClose()}>
      <DialogContent showCloseButton={false} className="max-w-[480px]">
        <DialogHeader>
          <DialogTitle>계정을 삭제하시겠습니까?</DialogTitle>
          <DialogDescription className="space-y-1 text-left">
            <span className="block">
              {email} ({name}) 계정이 삭제됩니다.
            </span>
            <span className="block">
              삭제된 계정은 로그인이 차단되며, 정산·감사 기록은 보존됩니다.
              해당 이메일은 90일간 재사용할 수 없습니다.
            </span>
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-1.5 text-left">
          <Label htmlFor="delete-account-confirm-id">
            확인을 위해 계정 ID를 입력하세요
          </Label>
          <Input
            id="delete-account-confirm-id"
            value={confirmId}
            onChange={(e) => setConfirmId(e.target.value)}
            placeholder={email}
            autoComplete="off"
            tone="error"
            aria-invalid={showErrorTone}
          />
        </div>

        <DialogFooter>
          <Button
            type="button"
            className={popupSecondaryButtonClassName}
            onClick={onClose}
          >
            취소
          </Button>
          <Button
            type="button"
            variant="destructive"
            className="h-12 flex-1 rounded-16 text-base font-semibold"
            disabled={!canDelete}
            onClick={() => {
              if (!canDelete) return;
              onConfirm();
            }}
          >
            삭제
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
